import { ReactNode } from "react";
import { DisableableLink } from "../../../../base_components/disableable_link";
import { usePublicCalendarContext } from "../hooks/use_public_calendar_context";

export function DashboardOrPublicLink(props: {
	to: string;
	children: ReactNode;
}) {
	const { is_public } = usePublicCalendarContext();

	if (is_public) {
		return (
			<a className="manual-link" href={props.to}>
				{props.children}
			</a>
		);
	}

	return <DisableableLink to={props.to}>{props.children}</DisableableLink>;
}
